// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5281":"bb523757d1459dba","7878":"5694821f70bdc686"}[chunkId] + ".js";
};